import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'

type Props = {
  label: string
  value: string
}

const ContractCardBody: FC<Props> = (props) => {
  const { label, value } = props
  return (
    <div className={styles.contract__detail}>
      <span>{label}</span>
      <span>{value}</span>
    </div>
  )
}

export default ContractCardBody
